import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CardsHistoryService {

  showHistory = true;
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  findAllByLoggedUser(page: number = 0, size: number = 9): Observable<any> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get(`${this.apiUrl}/cards-history`, {params})
  }

  saveCardsHistory(userCardId: bigint): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/cards-history/cardId/${userCardId}`, {});
  }

  deleteById(id: bigint): Observable<any> {
    return this.http.delete(`${this.apiUrl}/cards-history/${id}`);
  }

  deleteAllByLoggedUser(): Observable<any> {
    return this.http.delete(`${this.apiUrl}/cards-history/clear`)
  }
}
